export const GET_METATX_ENABLED = "coinshift/metatx/GET_METATX_ENABLED";
export const GET_METATX_ENABLED_SUCCESS =
  "coinshift/metatx/GET_METATX_ENABLED_SUCCESS";
export const GET_METATX_ENABLED_ERROR =
  "coinshift/metatx/GET_METATX_ENABLED_ERROR";
